import { z } from "zod";

export const getUserSchema = z.object({
	userId: z.string().nonempty(),
});

export type GetUserSchema = z.infer<typeof getUserSchema>;
